import { request } from './request';

export const getAllTreatingOrgs = () => request('treating_orgs');
